export default __webpack_public_path__ + "static/media/Gellix-Black.9268c734.woff2";